import config from '@/config';
import Location from '@/ports-frontend/Location';

import { isValidURL } from './utils';

const storage = {
  basePath: '',
  location: {
    origin: '',
  },
};

export async function getPageUrl(path?: string) {
  if (!path) {
    const location = await Location.get();
    return `${config.urls.app}${location.pathname}`;
  }
  if (isValidURL(path)) return path;

  return `${config.urls.app}${storage.basePath}${path}`;
}

export async function getCurrentPageHash() {
  const location = await Location.get();
  return location.hash;
}

function createRoutePath(routePath: string, dynamicParams?: string[]) {
  let newRoute = routePath;
  const matchedValues = routePath.match(/[:][a-z]*/g)!;

  dynamicParams &&
    matchedValues.forEach((value, index) => {
      newRoute = newRoute.replace(value, dynamicParams[index]);
    });

  return newRoute;
}

export function getDynamicRoutePath(pageId: string, params: string[]) {
  const route = config.routes
    .filter(route => route.id === pageId && route.type === 'dynamic')
    .find(route => (params.length ? route : route.slug));

  const extendedParams = route?.slug ? [route.slug, ...params] : params;

  return (
    route && `${storage.basePath}${createRoutePath(route.path, extendedParams)}`
  );
}
